<mat-card>
  <mat-card-title>
    {{ '+REPLACE_GATEWAY_MODAL.TITLE' | translate }}
  </mat-card-title>
  <mat-card-content>
    <form
      [formGroup]="replaceGatewayFormGroup"
      class="replace-gateway flex flex-row xs:flex-col justify-center items-start"
    >
      <div class="current flex flex-1 w-[100%] flex-col gap-[8px]">
        <div class="flex flex-col">
          <label>{{ '+REPLACE_GATEWAY_MODAL.CURRENT_GATEWAY_ID' | translate }} (*)</label>
          <mat-form-field mat-input-height-small floatLabel="always">
            <input
              gtm="onTextField"
              gtmId="current-gateway-id"
              gtmAction="Current gateway id"
              gtmCategory="replaceGatewayForm"
              [gtmOn]="['change', 'focus', 'blur']"
              name="oldGatewaySerial"
              formControlName="oldGatewaySerial"
              data-at-old-gateway-serial-input
              matInput
              required
            />
          </mat-form-field>
        </div>

        <div class="flex flex-col">
          <label>{{ '+REPLACE_GATEWAY_MODAL.CURRENT_GATEWAY_PASSWORD' | translate }} (*)</label>
          <mat-form-field mat-input-height-small floatLabel="always">
            <input
              gtm="onTextField"
              gtmId="current-gateway-password"
              gtmAction="Current gateway password"
              gtmCategory="replaceGatewayForm"
              [gtmOn]="['change', 'focus', 'blur']"
              name="oldGatewayPassword"
              formControlName="oldGatewayPassword"
              data-at-old-gateway-password-input
              matInput
              type="password"
              required
            />
          </mat-form-field>
        </div>
      </div>
      <span class="divider hidden xs:inline-block"></span>
      <div class="new flex flex-1 w-[100%] flex-col gap-[8px]">
        <div class="flex flex-col">
          <label>{{ '+REPLACE_GATEWAY_MODAL.NEW_GATEWAY_ID' | translate }} (*)</label>
          <mat-form-field mat-input-height-small floatLabel="always">
            <input
              gtm="onTextField"
              gtmId="new-gateway-id"
              gtmAction="New gateway id"
              gtmCategory="replaceGatewayForm"
              [gtmOn]="['change', 'focus', 'blur']"
              name="newGatewaySerial"
              formControlName="newGatewaySerial"
              data-at-new-gateway-serial-input
              matInput
              required
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>{{ '+REPLACE_GATEWAY_MODAL.NEW_GATEWAY_PASSWORD' | translate }} (*)</label>
          <mat-form-field mat-input-height-small floatLabel="always">
            <input
              gtm="onTextField"
              gtmId="new-gateway-password"
              gtmAction="New gateway password"
              gtmCategory="replaceGatewayForm"
              [gtmOn]="['change', 'focus', 'blur']"
              name="newGatewayPassword"
              formControlName="newGatewayPassword"
              data-at-new-gateway-password-input
              matInput
              type="password"
              required
            />
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-center items-center">
    <button
      data-at-cancel-button
      mat-stroked-button
      gtm="onCancelDialog"
      gtmCategory="replaceGateway"
      gtmAction="cancel"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-replace-gataway-button
      mat-raised-button
      gtm="onInstallationDeregister"
      gtmCategory="replaceGateway"
      gtmAction="confirm"
      color="primary"
      (click)="onConfirm()"
      [disabled]="replaceGatewayFormGroup.invalid"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
